import * as React from "react";
import { Box, Grid, Paper, Stack } from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView";
import styled from "styled-components";
import request from "src/utils/request";
import type { Template as templateType } from "src/components/template/types";
import Template from "src/components/template/template";
import fetchStatus from "src/utils/api/fetch-status";
import MissionsAchievementsTemplate from "src/scenes/dashboard/overview-components/questions-assets/missions-achievements-template";
import questionsMockTemplates from "src/scenes/dashboard/mock-data/questions-templates-mock-data";

const SectionTitle = styled.h2`
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    margin: 0;
`;

const QuestionPaper = styled(Paper)`
    width: 296px;
    height: 80px;
    border-radius: 14px;
    cursor: pointer;
    outline: ${({ selectedQuestion, id }) => {
        if (selectedQuestion === id) return "2px solid";
        return "none";
    }};
    outline-color: ${({ theme, selectedQuestion, id }) => {
        if (selectedQuestion === id) return theme.palette.primary.main;
        return "none";
    }};
    &:hover {
        transform: scale(1.01);
        outline: 1px solid ${({ theme }) => theme.palette.primary.main};
    }
`;

const QuestionsSection = ({ isDemo, selectedQuestion, setSelectedQuestion, questions }) => {
    const [earliestFirstScrapped, setEarliestFirstScrapped] = React.useState<{
        [id: string]: string;
    }>({});
    const [apiStatus, setApiStatus] = React.useState<{
        [id: string]: { status: fetchStatus | null; errorCode: number | null };
    }>({});
    const [templateNoData, setTemplateNoData] = React.useState({});
    const [template, setTemplate] = React.useState<templateType>();
    const handleCardClick = (id) => {
        setSelectedQuestion(id);
    };
    console.log(earliestFirstScrapped, apiStatus, templateNoData);
    const getTemplate = async () => {
        let res;
        if (isDemo) {
            res = questionsMockTemplates[selectedQuestion];
        } else {
            res = await request<templateType>(`api/template/?id=${selectedQuestion}`);
        }
        setTemplate(res);
    };

    React.useEffect(() => {
        if (selectedQuestion && selectedQuestion !== "goals") getTemplate();
    }, [selectedQuestion]);

    return (
        <>
            <Stack direction="row" spacing={1} alignItems="center">
                <SectionTitle>Recommended questions</SectionTitle>
            </Stack>
            <Stack alignItems="center" spacing={2} mb={2}>
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-start"
                    spacing={2}
                    mb={3}
                >
                    {questions &&
                        questions.length !== 0 &&
                        questions.questions.map((question) => {
                            return (
                                <Grid item>
                                    <QuestionPaper
                                        onClick={() => handleCardClick(question.questionId)}
                                        selectedQuestion={selectedQuestion}
                                        id={question.questionId}
                                    >
                                        <Stack
                                            direction="row"
                                            p={1.5}
                                            spacing={1}
                                            style={{ alignItems: "center", height: "100%" }}
                                        >
                                            <Box
                                                style={{
                                                    height: "36px",
                                                    width: "36px",
                                                    backgroundColor: "#303030",
                                                    borderRadius: "24px",
                                                    marginRight: "6px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <GridViewIcon
                                                    style={{
                                                        fontSize: "20px",
                                                        opacity: 0.7,
                                                    }}
                                                />
                                            </Box>
                                            <p
                                                style={{
                                                    margin: "0",
                                                    fontSize: "13px",
                                                    fontWeight: "300",
                                                    paddingBottom: "8px",
                                                    paddingTop: "8px",
                                                    maxWidth: "223px",
                                                }}
                                            >
                                                {question.questionHeader}
                                            </p>
                                        </Stack>
                                    </QuestionPaper>
                                </Grid>
                            );
                        })}
                </Grid>
            </Stack>
            {!selectedQuestion && (
                <Stack style={{ width: "100%" }} alignItems="center" mt={2}>
                    <p style={{ fontSize: "13px", opacity: "0.6" }}>
                        Please select one of the questions above.
                    </p>
                </Stack>
            )}
            {selectedQuestion === "goals" && <MissionsAchievementsTemplate />}
            {template && selectedQuestion !== "goals" && (
                <Template
                    viewType="user"
                    toolsScrapping={[]}
                    template={template}
                    defaultDateRange="week"
                    setTemplateNoData={(noData) =>
                        setTemplateNoData((prevState) => ({
                            ...prevState,
                            [template?.id]: noData,
                        }))
                    }
                    setEarliestFirstScrapped={(fsd) =>
                        setEarliestFirstScrapped((prevState) => ({
                            ...prevState,
                            [template?.id]: fsd,
                        }))
                    }
                    setApiStatus={(status, errorCode) =>
                        setApiStatus((prevState) => ({
                            ...prevState,
                            [template?.id]: { status, errorCode },
                        }))
                    }
                    templateIndex={1}
                    onEditMode={false}
                />
            )}
        </>
    );
};

export default QuestionsSection;
